'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _formSubReducerWrapper = require('../../../components/form/formSubReducerWrapper');

var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);

var _loginFormConstants = require('./loginFormConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var loginSubFormReducer = function loginSubFormReducer(state, action) {
    switch (action.type) {
        default:
            return state;
    }
};

// Constants
exports.default = (0, _formSubReducerWrapper2.default)(loginSubFormReducer, _loginFormConstants.LOGIN_FORM_NAME);


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/login/loginFormReducer.js
// module id = 1683
// module chunks = 0